import { FEATURES } from '@constants/Text'

// Override de desenvolvimento: para testar a navegação 2026 sem o backend ligar a
// flag, rode no console `localStorage.setItem('nav2026', '1')` e recarregue.
// O override só LIGA o protótipo — nunca desliga a navegação real de produção.
export const DEV_OVERRIDE_KEY = 'nav2026'

/**
 * Diz se a navegação 2026 deve ficar ativa, considerando a feature flag real
 * (backend) e o override de desenvolvimento via localStorage.
 * @param {Object} access store.getters['parameters/show']
 * @returns {boolean}
 */
export function isNav2026Enabled(access) {
  const show = access || {}
  if (show[FEATURES.NAVEGACAO_2026]) return true
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(DEV_OVERRIDE_KEY) === '1'
    )
  } catch {
    // localStorage indisponível (modo privado/bloqueado): mantém o protótipo desligado.
    return false
  }
}
